
import { Button, Form } from "react-bootstrap";
import Select from "react-select";
import Success_Toster from "../../../../../../../common/common_modal/success_toster/Success_Toster";
import { useEffect, useState } from "react";

function Externally_Service_Form({handleClose}) {
  const [success, setSuccess] = useState(false);

  // ⏱ auto hide success toaster after 3 sec
  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => {
        setSuccess(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [success]);
  const serviceUsedOptions = [
    { value: "calibration", label: "Calibration Service" },
    { value: "maintenance", label: "Maintenance Service" },
    { value: "repair", label: "Repair Service" },
  ];

  const performanceOptions = [
    { value: "excellent", label: "Excellent" },
    { value: "good", label: "Good" },
    { value: "average", label: "Average" },
    { value: "poor", label: "Poor" },
  ];

  return (
    <>
      <section className="Legal_Entity_Form">
        <div className="white_container customer_section">
          <div className="row">

            {/* Name Of Vendor */}
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Name Of Vendor</Form.Label>
                <Form.Control placeholder="Enter Name Of Vendor" />
              </Form.Group>
            </div>

            {/* Address */}
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Address</Form.Label>
                <Form.Control placeholder="Enter Address" />
              </Form.Group>
            </div>

            {/* Contact Person */}
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Contact Person</Form.Label>
                <Form.Control placeholder="Enter Contact Person" />
              </Form.Group>
            </div>

            {/* Email */}
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Email</Form.Label>
                <Form.Control placeholder="Enter Email" />
              </Form.Group>
            </div>

            {/* Mobile No */}
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Mobile No</Form.Label>
                <Form.Control placeholder="Enter Mobile No" />
              </Form.Group>
            </div>

            {/* Service Used */}
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Service Used</Form.Label>
                <Select
                  options={serviceUsedOptions}
                  placeholder="Select Service Used"
                  classNamePrefix="react_select"
                />
              </Form.Group>
            </div>

            {/* Performance */}
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Performance</Form.Label>
                <Select
                  options={performanceOptions}
                  placeholder="Select Performance"
                  classNamePrefix="react_select"
                />
              </Form.Group>
            </div>

            {/* Remark */}
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Remark</Form.Label>
                <Form.Control placeholder="Enter Remark" />
              </Form.Group>
            </div>

          </div>

          {/* Buttons */}
           <div className="permission_btn_holder">
            {success ? (
              <Success_Toster successText="Save Audit Successfully!" />
            ) : (
              <>
                <Button type="button" className="permission_btn No_btn">
                  Cancel
                </Button>

                <Button
                  type="button"
                  className="permission_btn Yes_btn"
                  onClick={() => setSuccess(true)}
                >
                  Save
                </Button>
              </>
            )}
          </div>
        </div>
      </section>
    </>
  );
}

export default Externally_Service_Form;
